import { ActionButton, OfficeButton } from 'components';

import { Action } from 'components/buttons/action-button';
import { DocumentTextIcon } from '@heroicons/react/24/outline'
import { ModalActions } from 'utils/types';
import { Treaty_treaty } from '_graphql/queries/__generated__/Treaty';
import numeral from 'numeral';
import { useAppNavigate } from '_graphql/cache/auth';
import { useUrlState } from 'utils';

type Props = {
    created: boolean;
    treaty: Treaty_treaty | null | undefined;
}

const TreatyAdjustmentStatment = ({ created, treaty }: Props) => {
    const [, setModal] = useUrlState("modal");
    const navigate = useAppNavigate()
    const handleAction = (id: string, action: Exclude<ModalActions, "expand" | "goto" | "clone">) => () => {
        navigate({
            search: (old) => ({
                ...old,
                id,
                modal: action,
            }),
        });
    };
    return (
        <div className="bg-card-500 rounded-xl shadow-lg overflow-hidden">
            <div className="px-6 py-5 border-b border-gray-700/50">
                <h3 className="text-xl font-semibold text-primary">Adjustment Statement</h3>
                <p className="mt-1 text-sm text-tertiary">Manage treaty adjustment statements</p>
            </div>

            <div className="p-6">
                <div className="bg-card-800/50 rounded-xl p-4">
                    <div className="flex gap-4">
                        <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-indigo-500/10 text-indigo-400">
                            <DocumentTextIcon className="h-6 w-6" />
                        </div>

                        {created ? (
                            <div className="flex flex-col justify-center flex-1">
                                <p className="text-sm text-primary">
                                    Adjustment Statement created for{" "}
                                    <span className="text-green-400 font-medium">
                                        {treaty?.currency} {numeral(treaty?.treaty_np_detail?.egrnpi).format("0,0.00")}
                                    </span>{" "}
                                    as Retained Premium Income.
                                </p>
                                <div className="mt-2 flex gap-3">
                                    <ActionButton
                                        action="update"
                                        onClick={handleAction(treaty?.treaty_np_detail?.treaty_np_id || "", "update-adjustment-statement")}
                                    />
                                    <ActionButton
                                        action="remove"
                                        onClick={handleAction(treaty?.treaty_np_detail?.treaty_np_id || "", "remove-adjustment-statement")}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="flex-1">
                                <p className="text-sm text-gray-500 mb-3">
                                    Create Adjustment Statement for{" "}
                                    <b className="text-green-600">
                                        {treaty?.currency} {numeral(treaty?.treaty_np_detail?.egrnpi).format("0,0.00")}
                                    </b>
                                </p>
                                <OfficeButton
                                    disabled={Boolean(created)}
                                    size="sm"
                                    onClick={() => setModal("add-adjustment-statement")}
                                >
                                    Create Adjustment Statement
                                </OfficeButton>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TreatyAdjustmentStatment